// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zfii","content":"styles_content__UwuiT"};